jQuery(document).ready(function(){
  updateIcons();
});

jQuery('.suosikki').click(function() {
  let id = jQuery(this).data('id');

  let suosikit = Cookies.get('suosikit');

  if ( suosikit ) {
    suosikit = JSON.parse(suosikit);
  }

  if ( suosikit && typeof suosikit == "object") {
    if ( id in suosikit ) {
      delete suosikit[id];
      jQuery(this).removeClass('suosikeissa');
      jQuery(this).addClass('ei-suosikeissa');
      if ( jQuery(this).hasClass('poistettavissa') ) {
        jQuery(this).closest('.excerpt-product').remove();
      }
    } else {
      suosikit[id] = 1;
      jQuery(this).addClass('suosikeissa');
      jQuery(this).removeClass('ei-suosikeissa');
    }
  } else {
    suosikit = {};
    suosikit[id] = 1;
    jQuery(this).addClass('suosikeissa');
    jQuery(this).removeClass('ei-suosikeissa');
  }


  if (jQuery(this).hasClass('poistettavissa') && suosikit.length <= 1) {
    if (suosikit.length < 1) {
      jQuery('.suosikit__tyhja.suosikit__tyhja--piilota').removeClass('suosikit__tyhja--piilota');
    } else {
      jQuery('.suosikit__tyhja').addClass('suosikit__tyhja--piilota');
    }
  }

  Cookies.set( 'suosikit', suosikit );
  updateIcons();
});

function updateIcons() {
  let suosikit = Cookies.get('suosikit');

  if ( suosikit ) {
    suosikit = JSON.parse(suosikit);

    jQuery('#header-icon-suosikit').html(Object.keys(suosikit).length);

    jQuery('.suosikki').each(function() {
      let id = jQuery(this).data('id');
      if ( id in suosikit ) {
        jQuery(this).addClass('suosikeissa');
      } else {
        jQuery(this).addClass('ei-suosikeissa');
      }
    });
  } 
}





// KOPIOI LINKKI LEIKEPÖYDÄLLE
jQuery('.suosikit-email__url').click(function() {
  var $temp = jQuery('<input>');
  var ele = jQuery(this);
  var val = jQuery(ele).data('value');
  jQuery('body').append($temp);
  $temp.val(val).select();
  document.execCommand("copy");
  $temp.remove();
  jQuery(ele).html('&#10003; Kopioitu');
  setTimeout(function () {
    jQuery(ele).html(val);
  }, 5000);
});